module.exports = __webpack_public_path__ + "static/media/KOR.3f5423d0.svg";